import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBreakpointChanged, removeOnBreakpointChanged } from '@/utils/viewport';
import {
  computed, inject, onBeforeUnmount, onMounted, ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseGridCol',
  props: {
    s: {},
    order: {},
    verticalStart: { type: Boolean },
    verticalCenter: { type: Boolean },
    verticalEnd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const defaultColSize = inject<Record<string, number> | number | string>('defaultColSize', 12);

const currentSize = ref<number>(12);
const colStyle = computed(() => ({
  gridColumn: `auto/span ${currentSize.value}`,
  order: props.order,
}));

const classes = computed(() => {
  const classesArr = [];

  if (props.verticalCenter) {
    classesArr.push('align-self-center');
  } else if (props.verticalEnd) {
    classesArr.push('align-self-end');
  } else if (props.verticalStart) {
    classesArr.push('align-self-start');
  }

  return classesArr;
});

const getCurrentSize = (event: CustomEvent) => {
  let size = props.s || defaultColSize;
  const breakpoints = (event.detail?.breakpoints || ['xs']) as string[];

  if (typeof size === 'object') {
    let sizeByBp = 0;
    const propBps = size;

    breakpoints.forEach((bpKey) => {
      if (Object.keys(size).includes(bpKey)) {
        sizeByBp = parseInt(`${propBps[bpKey] || size || 0}`, 10);
      }
    });

    size = sizeByBp || 12;
  }

  currentSize.value = parseInt(`${size || 12}`, 10);
};

onMounted(() => {
  onBreakpointChanged(getCurrentSize, true);
});

onBeforeUnmount(() => {
  removeOnBreakpointChanged(getCurrentSize);
});

return (_ctx: any,_cache: any) => {
  return (currentSize.value <= 12 && _ctx.order !== -1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["app-grid__col", classes.value]),
        style: _normalizeStyle(colStyle.value)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6))
    : _createCommentVNode("", true)
}
}

})